/**
 * WebView bridge helpers for native Google / Apple sign-in.
 */

const hasNativeBridge = () =>
  typeof window !== 'undefined' &&
  window.ReactNativeWebView &&
  typeof window.ReactNativeWebView.postMessage === 'function';

export const isText2MobileApp = () => hasNativeBridge();

export const requestNativeOAuthSignIn = (provider) => {
  if (!hasNativeBridge()) {
    return Promise.resolve({
      success: false,
      message: 'Mobil uygulama köprüsü bulunamadı',
    });
  }

  return new Promise((resolve) => {
    const timeout = window.setTimeout(() => {
      cleanup();
      resolve({ success: false, message: 'Giriş yanıt vermedi. Uygulamayı güncelleyip tekrar dene.' });
    }, 45000);

    const listener = (event) => {
      const detail = event && event.detail;
      if (!detail || detail.type !== 'OAUTH_SIGN_IN_RESULT' || detail.provider !== provider) {
        return;
      }
      cleanup();
      resolve({
        success: !!detail.success,
        idToken: detail.idToken || '',
        message: detail.message || '',
      });
    };

    const cleanup = () => {
      window.clearTimeout(timeout);
      window.removeEventListener('text2-native-oauth', listener);
    };

    window.addEventListener('text2-native-oauth', listener);
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ type: 'OAUTH_SIGN_IN', provider }),
    );
  });
};

export const subscribeNativeOAuthEvents = (handler) => {
  const listener = (event) => {
    if (event && event.detail) {
      handler(event.detail);
    }
  };
  window.addEventListener('text2-native-oauth', listener);
  return () => window.removeEventListener('text2-native-oauth', listener);
};

export const waitForNativeOAuthBridge = () =>
  new Promise((resolve) => {
    if (typeof window === 'undefined') {
      resolve(false);
      return;
    }
    if (window.text2OAuth && window.text2OAuth.ready) {
      resolve(true);
      return;
    }
    const onReady = () => {
      window.removeEventListener('text2-oauth-ready', onReady);
      resolve(true);
    };
    window.addEventListener('text2-oauth-ready', onReady);
    window.setTimeout(() => {
      window.removeEventListener('text2-oauth-ready', onReady);
      resolve(!!(window.text2OAuth && window.text2OAuth.ready));
    }, 3000);
  });
